import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { frontendserverurl, serverurl } from "../../environments/environment";
import { ConnectionDeletionRequiredComponent } from '../home/figma-exports/connection-deletion-required/connection-deletion-required.component';
import { StreamOrderItem } from "../interfaces/generic-streams";
import {
    EditingStreamObject,
    GenericStepConfig,
    GenericStepConfigList,
    GenericStream,
} from "../lib/interfaces/generic-streams";
import { SnackService } from "./snack.service";

@Injectable({
    providedIn: 'root',
})
export class GenericStreamsService {
    http = inject(HttpClient);
    snack = inject(SnackService);
    dialog = inject(MatDialog);

    allStreams: GenericStream[] = [];


    async deleteFigmaSiteExports(id: string): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http
                .delete(`${frontendserverurl}/webhooks/figma-export/${id}`)
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        if(err.error.streams.length > 0) {
                            let dia = this.dialog.open(ConnectionDeletionRequiredComponent, {
                                panelClass: "small-dialog",
                                autoFocus: false,
                                data: { streams: err.error.streams },
                            });
                        }
                        resolve(false);
                    },
                });
        });
    }

    async triggerAgentUpdate(): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http
                .post(`${frontendserverurl}/aiservice/agents/update`, {})
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async getAllStreamOrder(): Promise<StreamOrderItem[] | false> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/tracks//category-stream-order`).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async emitStreamOrderChanges(data: StreamOrderItem[]): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http.put(`${serverurl}/tracks//category-stream-order`, { data }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async updateFigmaSiteExports(id: string, name: string, url: URL) {
        return await new Promise((resolve) => {
            this.http
                .put(`${frontendserverurl}/webhooks/figma-export/${id}`, {
                    name,
                    url,
                })
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(data.data);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async getStreamCategoryMatch(): Promise<{ id: string, name: string, categoryId: string[] }[] | false> {
        return await new Promise((resolve) => {
            this.http
                .get(`${serverurl}/tracks/genericstream-data/stream-category-match`)
                .subscribe({
                    next: async (data: any) => {
                        resolve(data as any);
                        // console.log(data);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async getFigmaSiteExports() {
        return await new Promise((resolve) => {
            this.http
                .get(`${frontendserverurl}/webhooks/figma-export`)
                .subscribe({
                    next: async (data: any) => {
                        resolve(data);
                        console.log(data);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async deleteFigmaExport(id: string): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http
                .delete(`${frontendserverurl}/webhooks/figma-export/${id}`)
                .subscribe({
                    next: async (data: any) => {
                        console.log(data);
                        this.snack.success(data);
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async extractFigmaSite(name: string, url: URL) {
        return await new Promise((resolve) => {
            this.http
                .post(`${frontendserverurl}/webhooks/figma-export`, {
                    name,
                    url,
                })
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(data.data);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async deleteEdittingModeForStream(streamId: string): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http
                .delete(`${serverurl}/tracks/checkstreamedit/${streamId}`)
                .subscribe({
                    next: async (data: any) => {
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async checkAndSetEdittingModeForStream(
        streamId: string,
    ): Promise<true | EditingStreamObject> {
        return await new Promise((resolve) => {
            this.http
                .post(`${serverurl}/tracks/checkstreamedit`, { streamId })
                .subscribe({
                    next: async (data: any) => {
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(err.error.user as EditingStreamObject);
                    },
                });
        });
    }
    async getOneGenericStream(id: string): Promise<false | GenericStream> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/tracks/genericstream/${id}`).subscribe({
                next: async (data: any) => {
                    data.globalStream = data.globalStream === 0 ? false : true;
                    try {
                        data.streamResults = JSON.parse(data.streamResults);

                    } catch (err) { }
                    try {
                        if (typeof data.promotionArea === 'string') {
                            try {
                                data.promotionArea = JSON.parse(data.promotionArea);
                            } catch (err) {
                                console.error('Failed to parse promotionArea:', err, data.promotionArea);
                            }
                        } else if (!data.promotionArea) {
                            data.promotionArea = {
                                status: false,
                                imgStatus: false,
                                imgUrl: null,
                                headline: null,
                                description: null,
                                targetUrl: null,
                                videos: []
                            };
                        }
                    } catch (err) { }

                    resolve(data as GenericStream);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                },
            });
        });
    }
    async getGenericStreams(): Promise<false | GenericStream[]> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/tracks/genericstream`).subscribe({
                next: async (data: any) => {
                    for await (let stream of data) {
                        stream.globalStream =
                            stream.globalStream === 0 ? false : true;
                        try {
                            stream.streamResults = JSON.parse(
                                stream.streamResults,
                            );
                        } catch (err: any) { }
                        try {
                            if (typeof stream.promotionArea === 'string') {
                                try {
                                    stream.promotionArea = JSON.parse(stream.promotionArea);
                                } catch (err) {
                                    console.error('Failed to parse promotionArea in getGenericStreams:', err, stream.promotionArea);
                                }
                            } else if (!stream.promotionArea) {
                                stream.promotionArea = {
                                    status: false,
                                    imgStatus: false,
                                    imgUrl: null,
                                    headline: null,
                                    description: null,
                                    targetUrl: null,
                                    videos: []
                                };
                            }
                        } catch (err: any) { }
                    }
                    this.allStreams = data;
                    resolve(data as GenericStream[]);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                },
            });
        });
    }
    async getPrivateGenericStreams(): Promise<
        false | { name: string; id: string; status: string }[]
    > {
        return await new Promise((resolve) => {
            this.http
                .get(`${serverurl}/tracks/genericstream/private`)
                .subscribe({
                    next: async (data: any) => {
                        resolve(
                            data as {
                                name: string;
                                id: string;
                                status: string;
                            }[],
                        );
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async updateGenericStream(data: GenericStream): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http
                .put(`${serverurl}/tracks/genericstream/${data.id}`, data)
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async addGenericStream(data: GenericStream): Promise<false | string> {
        return await new Promise((resolve) => {
            this.http
                .post(`${serverurl}/tracks/genericstream`, data)
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(data.id as string);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async deleteGenericStream(id: string): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http
                .delete(`${serverurl}/tracks/genericstream/${id}`)
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    // GENERIC CONFIG STUFF
    async updateGenericStepConfig(data: GenericStepConfig): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http
                .put(`${serverurl}/tracks/generic-config`, data)
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async addGenericStepConfig(
        data: GenericStepConfig,
    ): Promise<false | string> {
        return await new Promise((resolve) => {
            this.http
                .post(`${serverurl}/tracks/generic-config`, data)
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(data.id as string);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async getGenericConfigList(): Promise<false | GenericStepConfigList[]> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/tracks/generic-config`).subscribe({
                next: async (data: any) => {
                    resolve(data as GenericStepConfigList[]);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                },
            });
        });
    }
    async getGenericConfigById(id: string): Promise<false | GenericStepConfig> {
        return await new Promise((resolve) => {
            this.http
                .get(`${serverurl}/tracks/generic-config/${id}`)
                .subscribe({
                    next: async (data: any) => {
                        data.websearchStatus =
                            data.websearchStatus === 0 ? false : true;
                        data.uploadStatus =
                            data.uploadStatus === 0 ? false : true;
                        if (data.websearchStatus === false) {
                            data.websearch = {
                                questions: [],
                                researchPrompt: '',
                                resultPrompt: '',
                            };
                        }
                        if (data.uploadStatus === false) {
                            data.upload = {
                                resultPrompt: '',
                            };
                        }
                        resolve(data as GenericStepConfig);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async deleteGenericConfigById(id: string): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http
                .delete(`${serverurl}/tracks/generic-config/${id}`)
                .subscribe({
                    next: async (data: any) => {
                        resolve(true);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async getConversations(): Promise<boolean | any> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/tracks/conversations`).subscribe({
                next: async (data: any) => {
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                },
            });
        });
    }
    async getConversationsForStream(streamId: string, time: string, user?: string,from?: number, to?: number): Promise<boolean | any> {
        return await new Promise((resolve) => {
            const params: string[] = [`time=${encodeURIComponent(time)}`];

            if (time === 'custom') {
                if (from) params.push(`from=${encodeURIComponent(from)}`);
                if (to) params.push(`to=${encodeURIComponent(to)}`);
            }

            if(user) {
                params.push(`userId=${encodeURIComponent(user)}`)
            }


            const queryString = params.join('&');
            this.http
                .get(`${serverurl}/tracks/conversations/${streamId}?${queryString}`)
                .subscribe({
                    next: async (data: any) => {
                        resolve(data);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async getCompaniesForPrivateGenericStream(
        streamId: string,
    ): Promise<boolean | any> {
        return await new Promise((resolve) => {
            this.http
                .get(
                    `${serverurl}/tracks/genericstream/private/${streamId}/companies`,
                )
                .subscribe({
                    next: async (data: any) => {
                        resolve(data);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
    async duplicateGenericStream(duplicateId: string): Promise<false | string> {
        return await new Promise((resolve) => {
            this.http
                .post(
                    `${serverurl}/tracks/genericstream/${duplicateId}/duplicate`,
                    {},
                )
                .subscribe({
                    next: async (data: any) => {
                        this.snack.success(data.msg);
                        resolve(data.id as string);
                    },
                    error: (err) => {
                        this.snack.error(err);
                        resolve(false);
                    },
                });
        });
    }
}
